import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';
import { StaticReferences } from './app/core/utils/static-references';
import { TableStateRepository } from './app/services/repositories/table-state.repository';
import { UnsyncedChangesRepository } from './app/services/repositories/unsynced-changes.repository';
import 'sweetalert2';

registerLocaleData(localeDe);

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
    .then((appRef) => {
    })
    .catch(err => console.error(err));
